import constant from '../../store/constant'
import config from '../../store/config'
var utils = require('../../utils')

export default {
  name: 'clinic-surrounding',
  data: function () {
    return {
      shopId: null,
      shop: null,
      clinicList: null,
      shopList: null
    }
  },
  created () {
    this.clinicList = this.$store.getters.searchClinicsByShop
    this.shopList = this.$store.getters.searchClinicsShopList
    this.getSelectShop()
  },
  computed: {
    loading () {
      return this.$store.getters.apiLoading
    },
    shops () {
      return this.$store.getters.shops
    },
    searchShopsCheck () {
      if ((this.searchShops === true) && (!this.clinicList)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    getSelectShop: function () {
      this.$store.dispatch('SHOP_SELECT_GET', {data: {shop_list: this.shopList}})
      .then(
        (res) => {this.searchCallback(res)},
        () => {this.goPrev()}
      )
    },
    searchCallback: function (data) {
      this.shop = data.data
      this.initGoogleMapsByShop()
    },
    /** コールバック */
    initGoogleMapsByShop: function () {
      var shopListCnt = 0
      var markaList = []
      if (utils.isPresent(this.clinicList) && this.clinicList.length > 0) {
        // 施設・個人宅 マーカー
        for (var i = 0; i < this.clinicList.length; i++) {
          var clinic = this.clinicList[i]

          if (this.shopList.data[shopListCnt] !== clinic['shop_id']) {
            shopListCnt += 1
          }
          var address = ''
          if (utils.isPresent(clinic['address1'])) {
            address += clinic['address1']
          }
          if (utils.isPresent(clinic['address2'])) {
            address += clinic['address2']
          }
          // var icon = constant.shopIcons[i % constant.shopIcons.length]
          markaList.push({
            lat:     clinic['map_lat'],
            lng:     clinic['map_lng'],
            zoom:    clinic['map_zoom'],
            title:   clinic['clinic_name'],
            address: address,
            icon:    constant.resIcons[shopListCnt]
          })
        }

        // 店舗 マーカー
        for (var i = 0; i < this.shop.length; i++) {
          var shop = this.shop[i]['attributes']
          var shop_address = ''
          if (utils.isPresent(shop['address1'])) {
            shop_address += shop['address1']
          }
          if (utils.isPresent(shop['address2'])) {
            shop_address += shop['address2']
          }

          markaList.push({
            lat:     shop['map-lat'],
            lng:     shop['map-lng'],
            zoom:    shop['map-zoom'],
            title:   shop['shop-name'],
            address: shop_address,
            icon:    constant.shopIcons[i]
          })
        }
        
      }
      
      utils.googleMapMarkaOnlyEvent({
        js:          constant.js.google_maps,
        key:         config.google_map_api_key,
        mapElmId:    'map',
        map_default: constant.map_default,
        markaList:   markaList,
        logoChange: false,
        logoLinkChange: false,
        showMarkerInfo: true,
      })
      
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query:{type: this.$router.currentRoute.query.type} })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query:{type: this.$router.currentRoute.query.type} })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query:{type: this.$router.currentRoute.query.type}})
    },
    goPrev: function () {
      this.$router.push({ path: '/clinics', query:{type: this.$router.currentRoute.query.type} })
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/scripts/clinic-surrounding.js